import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import auth, {getAuth, onAuthStateChanged} from "firebase/auth";
import {firebaseApp} from "../database/config/firebase.config";
import {findIsAllowedUserByEmail} from "../database/queries/queries";

interface GoogleAuthContextProviderProps {
    children: ReactNode;
}

export function useGoogleAuthContext() {
    const context = useContext(GoogleAuthContext);
    if (context === undefined) {
        throw new Error('useGoogleAuthContext must be called within its Provider')
    }
    return context;
}

type GoogleAuthContextProps = {
    authenticated: boolean | null; auth: auth.Auth; user: auth.User | null; loading: boolean;
};

const GoogleAuthContext = createContext({} as GoogleAuthContextProps)

export default function GoogleAuthContextProvider({children}: GoogleAuthContextProviderProps) {


    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState<auth.User | null>(null);
    const auth = getAuth(firebaseApp);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (!firebaseUser) {
                setUser(null);
                setAuthenticated(false);
                setLoading(false);
                return;
            }

            try {
                const isAllowedUserEmail = await findIsAllowedUserByEmail(firebaseUser.email || "");

                if (!isAllowedUserEmail) {
                    await auth.signOut();
                    setUser(null);
                    setAuthenticated(false);
                    setLoading(false);
                    return;
                }

                setUser(firebaseUser);
                setAuthenticated(true);
                setLoading(false);
            } catch (error) {
                console.error("GoogleAuthContext: erro ao validar usuario", error);
                await auth.signOut();
                setUser(null);
                setAuthenticated(false);
                setLoading(false);
            }
        });

        return () => unsubscribe();
    }, [auth]);


    return (<GoogleAuthContext.Provider value={{authenticated, auth, user, loading}}>
        {children}
    </GoogleAuthContext.Provider>);

}